import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0e86ac48"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "product-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "station-title dis-space-3 me-top-lg"
}, "化工业务管理困境", -1));
const _hoisted_3 = {
  class: "station-adv me-top-lg"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "station-adv-title me-sub-title dis-space-2"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "station-adv-line"
}, null, -1));
const _hoisted_7 = {
  class: "station-adv-content me-content dis-space-1"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "management-title dis-space-3"
}, "采销管理系统", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "management-des me-sub-title me-top dis-space-1"
}, "为化工企业提供采购和销售线上管理服务，优化企业业务流程，便捷实现企业供应商管理、自动收发货、无人值守称重管理、结算支付等管控目标。", -1));
const _hoisted_10 = {
  class: "management-img me-top"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "interface-title dis-space-3"
}, "软件界面", -1));
const _hoisted_13 = {
  class: "interface-img me-top me-padding-H1"
};
const _hoisted_14 = {
  class: "interface-img-content"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "advantage-title dis-space-3"
}, "核心优势", -1));
const _hoisted_17 = {
  class: "advantage-list me-top-lg"
};
const _hoisted_18 = {
  class: "me-sub-title dis-space-2"
};
const _hoisted_19 = {
  class: "me-content dis-space-1"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["station", {
      'station-chemical-entry': true
    }]),
    id: "station-chemical",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chemicalList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "station-adv-item",
      key: index
    }, [_createElementVNode("img", {
      src: item.img,
      alt: ""
    }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1), _hoisted_6, _createElementVNode("div", _hoisted_7, _toDisplayString(item.content), 1)]);
  }), 128))])], 4), _createElementVNode("div", {
    class: _normalizeClass(["management", {
      'management-chemical-entry': _ctx.managementChemicalState.showTime
    }]),
    id: "management-chemical",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_hoisted_8, _hoisted_9, _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.manageList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "me-padding-H1"
    }, [_createElementVNode("img", {
      src: item.img,
      alt: ""
    }, null, 8, _hoisted_11)]);
  }), 128))])], 6), _createElementVNode("div", {
    class: _normalizeClass(["interface", {
      'interface-chemical-entry': _ctx.interfaceChemicalState.showTime
    }]),
    id: "interface-chemical"
  }, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
    src: require('@/assets/img/product/chemical/chemical8.png'),
    alt: ""
  }, null, 8, _hoisted_15)])])], 2), _createElementVNode("div", {
    class: _normalizeClass(["advantage", {
      'advantage-entry': _ctx.advantageState.showTime
    }]),
    id: "advantage"
  }, [_hoisted_16, _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.advantageList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "advantage-list-item",
      key: index
    }, [_createElementVNode("span", null, "0" + _toDisplayString(index + 1), 1), _createElementVNode("h3", _hoisted_18, _toDisplayString(item.title), 1), _createElementVNode("label", _hoisted_19, _toDisplayString(item.content), 1)]);
  }), 128))])], 2)]);
}